const searchOptions = [
  {path: '/food', title: 'Search for a Food'},
  {path: '/nutrient', title: 'Search for a Nutrient'},
  {path: '/multifood', title: 'Multi-Food Search'},
  {path: '/multinutrient', title: 'Multi-Nutrient Search'},
];

export default searchOptions;



// WEBPACK FOOTER //
// ./src/components/search/searchNav/searchOptions.js